const IS_DEV_ENV = import.meta.env.DEV;

export const hasRole = (user, role) => {
    if (!role) {
        return true;
    }

    const userRoles = user?.roles || (IS_DEV_ENV ? ['SUPER_ADMIN'] : []);
    if (userRoles.includes('SUPER_ADMIN')) {
        return true;
    }
    return userRoles.includes(role);
};

export const hasAnyRoles = (user, roles) => {
    if (!roles) {
        return true;
    }

    const userRoles = user?.roles || (IS_DEV_ENV ? ['SUPER_ADMIN'] : []);
    if (userRoles.includes('SUPER_ADMIN')) {
        return true;
    }
    return userRoles.some((x) => roles.includes(x));
};

export const hasAllRoles = (user, roles) => {
    if (!roles) {
        return true;
    }

    const userRoles = user?.roles || (IS_DEV_ENV ? ['SUPER_ADMIN'] : []);
    if (userRoles.includes('SUPER_ADMIN')) {
        return true;
    }
    return roles.every((x) => userRoles.includes(x));
};

export const hasRouteAccess = (userProfile, routeAccess) => {
    if (!routeAccess) {
        return true;
    }

    if (!userProfile) {
        return false;
    }

    if (routeAccess.requireAll) {
        return hasAllRoles(userProfile, routeAccess.roles);
    }

    return hasAnyRoles(userProfile, routeAccess.roles);
};
